<template>
  <LadDialog
    :visible="open"
    :handle-before-close="handleClose"
    class="lad-itinerary-download--dialog"
  >
    <template slot="dialog-header">
      <span>{{ $t(`${base}.download`) }}</span>
    </template>

    <template slot="dialog-body">
      <LadZohoFormLead :item="item" @submitted="handleSubmitted">
        <template v-if="submitted" slot="sent">
          <LadFacebookWidget
            v-if="sent"
            :group-id="exExperience.facebook_group_id"
          />

          <div v-else class="itinerary-download-btn">
            <el-button
              type="success"
              :loading="loading"
              :disabled="loading"
              @click="handleDownload"
              >{{ $t(`${base}.download`) }}</el-button
            >

            <h3 v-if="loading">{{ $t(`${base}.downloading`) }}</h3>
          </div>
        </template>
      </LadZohoFormLead>
    </template>

    <template slot="dialog-footer">
      <el-button @click="handleClose">{{ $t('general.close') }}</el-button>
    </template>
  </LadDialog>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import GenericEventMixin from '@/utils/mixin/generic-event'
import LadFacebookWidget from /* webpackChunkName: "lad-face-widget" */ '@/components/facebook/widget'
import { downloadFile } from '@/utils'

export default {
  name: 'LadItineraryDownloadDialogZoho',
  components: {
    LadFacebookWidget,
    LadDialog: () =>
      import(
        /* webpackChunkName: "lad-dialog" */ '@/components/frontends/Modal/index'
      ),
    LadZohoFormLead: () =>
      import(
        /* webpackChunkName: "lad-zoho-form--lead" */ '@/components/zoho-form/lead'
      ),
  },
  mixins: [GenericEventMixin],
  props: {
    open: { type: Boolean, required: true },
    item: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      base: 'components.itinerary.download',
      loading: false,
      sent: false,
      submitted: false,
    }
  },
  computed: {
    ...mapState('experience', {
      exExperience: (state) => state.experience,
      totalAmount: (state) => state.sales_plan.total_amount,
    }),
    ...mapState('settings', ['currency']),
    hasValidItem() {
      return Object.keys(this.item).length > 0
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSubmitted() {
      this.submitted = true
    },
    async handleDownload(scope) {
      this.$store.dispatch('app/setPromptInstall', {
        showPromptInstall: true,
        source: 'after_download_itinerary',
      })

      this.loading = true
      const url = `/api/v1.5/experiences/export/${
        this.hasValidItem ? this.item.uuid : this.exExperience.uuid
      }/pdf/itinerary`

      this.$axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const data = { blob: response }
          downloadFile(data, 'itinerary')
          this.sent = true
        })
        .finally(() => (this.loading = false))

      if (this.$route.name.startsWith('landing-permalink')) {
        const data = {
          name: 'download_itinerary',
          currency: this.currency,
          experience: {
            ...(this.hasValidItem
              ? { ...this.item, name: this.item.title }
              : this.exExperience),
            total_amount: this.hasValidItem
              ? this.item.total_amount
              : this.totalAmount,
          },
        }

        const params = {
          content_type: 'destination',
          content_ids: [
            this.hasValidItem ? this.item.uuid : this.exExperience.uuid,
          ] /** specific to the top 3-5 destinations listed in search results */,
          content_name: null,
          travel_start: null /** solo aplica cuando hay filtro de rango de fecha */,
          travel_end: null /** solo aplica cuando hay filtro de rango de fecha */,
          city: null /** solo aplica cuando se busca por ciudad */,
          region: null /** region or state => no aplica de momento */,
          country: null /** se obtiene del primer item */,
          num_adults: null,
          num_children: null /** if applicable> */,
          value: this.hasValidItem ? this.item.total_amount : this.totalAmount,
          currency: this.currency,
          event_id: `${this.deviceId}-${Date.now()}`,
        }

        const conversion = {
          type: 'download_itinerary',
          source_url: window.location.href,
          cookies: {
            _fbp: Cookies.get('_fbp') || '',
            _fbc: Cookies.get('_fbc') || '',
          },
          params: this.$route.query || {},
        }

        await this.$axios.post(
          `/api/conversion/${this.isAuth ? 'user' : 'guest'}`,
          { ...params, ...conversion }
        )

        await this.sendGenericEvent(data)
      }
    },
  },
}
</script>

<style lang="scss">
.lad-itinerary-download--dialog {
  .el-dialog__body-wrapper {
    padding: 0;
  }

  .el-dialog {
    margin-top: 5vh !important;
    height: 90vh;
  }

  .lad-zoho {
    .el-main {
      margin-bottom: 0;
    }

    &--header {
      padding-top: 0;
    }
  }

  .itinerary-download-btn {
    text-align: center;
  }
}
</style>
